export * from './DocArrowInIcon';
export * from './DocArrowInIcon16Light';
export * from './DocArrowInIcon16Regular';
export * from './DocArrowInIcon16Solid';
export * from './DocArrowInIcon20Light';
export * from './DocArrowInIcon20Regular';
export * from './DocArrowInIcon20Solid';
export * from './DocArrowInIcon24Regular';
export * from './DocArrowInIcon24Solid';
export * from './DocArrowInIcon32Regular';
export * from './DocArrowInIcon64Regular';
